var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { billDefaultDate } from "../../../helper/defaultDate";
function getDefaultFormData() {
    return {
        poster_type: '-1',
        poster_status: '-1',
        s_time: billDefaultDate().Start.format('yyyy-MM-dd'),
        e_time: billDefaultDate().End.format('yyyy-MM-dd'),
        poster_code: '',
    };
}
var BillHeader = (function (_super) {
    __extends(BillHeader, _super);
    function BillHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = getDefaultFormData();
        _this.posterTypeList = [
            {
                name: '全部',
                id: '-1'
            },
            {
                name: '店铺',
                id: '1'
            },
            {
                name: '货品',
                id: '2'
            },
            {
                name: '活动',
                id: '3'
            },
        ];
        _this.actStatusList = [
            {
                name: '全部',
                id: '-1'
            },
            {
                name: '已发布',
                id: '1'
            },
            {
                name: '未发布',
                id: '0'
            },
        ];
        return _this;
    }
    BillHeader.prototype.created = function () {
    };
    BillHeader.prototype.search = function () {
        this.$emit('search', __assign({}, this.formData));
    };
    BillHeader.prototype.reset = function () {
        this.formData = getDefaultFormData();
    };
    BillHeader = __decorate([
        Component
    ], BillHeader);
    return BillHeader;
}(Vue));
export default BillHeader;
